import { algoliaApiSearch } from 'algolia-api/algoliaApiSearch';
import { AlgoliaApiListingResult } from 'algolia-api/listing/types/AlgoliaApiListingResult';
import { algoliaApiGetSearchConfig } from 'algolia-api/search/algoliaApiGetSearchConfig';
import getSearchLocationOptions from 'algolia-api/search/getSearchLocationOptions';
import { getVolopsSearchIndex } from 'algolia-api/search/getVolopsSearchIndex';
import { QueryOptions } from 'algolia-api/types/QueryOptions';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { ApiVolopFunction } from 'api/types/ApiVolopFunction';

export async function algoliaApiGetRecommendedActions(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  queryOptions?: QueryOptions,
  options?: {
    volopFunction?: ApiVolopFunction | null | undefined;
    areaOfFocus?: ApiAreaOfFocus | null | undefined;
    locale?: UserLocale | 'all';
  },
) {
  const searchConfig = algoliaApiGetSearchConfig();
  let locationOptions = {};

  if (searchLocation?.latitude && searchLocation?.longitude) {
    locationOptions = getSearchLocationOptions(
      'auto',
      searchLocation,
    ).locationOptions;
  }

  const filters = [
    'actionType:VOLOP',
    'source:IDEALIST',
    options?.volopFunction && `(functions:'${options.volopFunction}')`,
    options?.areaOfFocus && `(areasOfFocus: '${options.areaOfFocus}')`,
    options?.locale &&
      options.locale !== 'all' &&
      `(locale: '${options.locale}')`,
  ]
    .filter(Boolean)
    .join(' AND ');

  const options2: QueryOptions = {
    index: getVolopsSearchIndex(),
    filters,
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
    ...queryOptions,
  };

  return algoliaApiSearch<AlgoliaApiListingResult>({
    config: searchConfig,
    query: '',
    queryOptions: options2,
  }).then(({ hits }) => hits);
}
